import { useAppStore } from '../../stores/app';
import { useGameEvents } from '../../hooks/useGameEvents';

const COLORS = ['red', 'blue', 'yellow', 'green'] as const;
const MARKERS = ['▲', '●', '■', '◆'];

export function AnswerButtons() {
  const options = useAppStore((s) => s.options);
  const selectedAnswer = useAppStore((s) => s.selectedAnswer);
  const answerSent = useAppStore((s) => s.answerSent);
  const gameStatus = useAppStore((s) => s.gameStatus);
  const roundResults = useAppStore((s) => s.roundResults);
  
  const { submitAnswer } = useGameEvents();

  const isQuestionPhase = gameStatus === 'question';
  const isResultsPhase = gameStatus === 'results';
  const correctIndex = roundResults?.question.correctIndex;

  const handleClick = (index: number) => {
    if (!isQuestionPhase || answerSent) return;
    submitAnswer(index);
  };

  return (
    <div className="grid grid-cols-1 gap-3 w-full max-w-md mx-auto">
      {options.map((option, index) => {
        const color = COLORS[index];
        const marker = MARKERS[index];
        const isSelected = selectedAnswer === index;
        const isCorrect = isResultsPhase && index === correctIndex;
        const isWrong = isResultsPhase && isSelected && index !== correctIndex;

        let className = `option-btn option-btn--${color}`;
        if (isSelected && !isResultsPhase) className += ' option-btn--selected';
        if (isCorrect) className += ' option-btn--correct';
        if (isWrong) className += ' option-btn--wrong';

        return (
          <button
            key={index}
            onClick={() => handleClick(index)}
            disabled={!isQuestionPhase || answerSent}
            className={className}
          >
            <span className="mr-3 opacity-70">{marker}</span>
            <span>{option}</span>
          </button>
        );
      })}
    </div>
  );
}

// Упрощённые кнопки только с цветами (для TV режима — игроки смотрят на экран)
export function AnswerButtonsSimple() {
  const selectedAnswer = useAppStore((s) => s.selectedAnswer);
  const answerSent = useAppStore((s) => s.answerSent);
  const gameStatus = useAppStore((s) => s.gameStatus);
  
  const { submitAnswer } = useGameEvents();

  const isQuestionPhase = gameStatus === 'question';

  const handleClick = (index: number) => {
    if (!isQuestionPhase || answerSent) return;
    submitAnswer(index);
  };

  if (answerSent) {
    return (
      <div className="text-center py-8">
        <div className="text-2xl mb-2">✓</div>
        <div className="text-gray-400">Ответ принят!</div>
        <div className="text-sm text-gray-500 mt-2">Смотри на экран</div>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 gap-4 w-full max-w-sm mx-auto">
      {COLORS.map((color, index) => {
        const isSelected = selectedAnswer === index;

        return (
          <button
            key={index}
            onClick={() => handleClick(index)}
            disabled={!isQuestionPhase}
            className={`
              aspect-square rounded-2xl text-4xl font-bold
              transition-all duration-200 active:scale-95
              ${color === 'red' ? 'bg-game-red' : ''}
              ${color === 'blue' ? 'bg-game-blue' : ''}
              ${color === 'yellow' ? 'bg-game-yellow text-black' : 'text-white'}
              ${color === 'green' ? 'bg-game-green' : ''}
              ${isSelected ? 'ring-4 ring-white' : ''}
              disabled:opacity-50
            `}
          >
            {MARKERS[index]}
          </button>
        );
      })}
    </div>
  );
}
